// Contenuti della pagina ORGANIZZAZIONE (informale, 02/11/2026).
// Per aggiornare la pagina basta modificare questo file: aree, persone, tasselli (NODI) e catene.
// NODI[x].porta = i tasselli che dipendono da x (se x manca, cadono anche loro).
// Le "prima serve" si calcolano da sole al contrario.
// Riferimenti allo statuto: versione caricata nel gestionale (senza data). Quando arriva il nuovo, ricontrollare gli articoli.

export const AREE = {
  DIR: { nome: 'Direttivo e rappresentanza', colore: '#9B1C3A', cosa: 'Decide le regole, il budget e i prezzi, firma i contratti, risponde verso l\'esterno.' },
  SEG: { nome: 'Segreteria e tesseramenti', colore: '#C24B08', cosa: 'Anagrafica, codici fiscali, tessere, libro soci, privacy, verbali.' },
  TEC: { nome: 'Area tecnica', colore: '#1F5FAF', cosa: 'Corsi, gruppi, allenatori, presenze, qualità sportiva.' },
  AMM: { nome: 'Amministrazione e soldi', colore: '#9A6A12', cosa: 'Incassi, banca, contanti, paghe, rendiconto, rapporti col commercialista.' },
  EVE: { nome: 'Tornei ed eventi', colore: '#2F7D4F', cosa: 'Calendario, campi, iscrizioni FIPAV/AIBVC, contabilità dei tornei.' },
  COM: { nome: 'Comunicazione e famiglie', colore: '#6D3FC0', cosa: 'Email, social, foto, rapporto con atleti e genitori, merchandising.' },
};

export const RISCHI = {
  ASSICURATIVO: '#B42318', FISCALE: '#9A6A12', ECONOMICO: '#1F5FAF', ORGANIZZATIVO: '#3B4452', FIDUCIA: '#6D3FC0', SPORTIVO: '#2F7D4F',
};

// Il direttivo oggi (da completare con i nomi di presidente e vicepresidente).
export const DIRETTIVO = [
  { ruolo: 'Presidente', nome: '', fa: 'Rappresenta l\'associazione e firma. Da solo può fare l\'ordinaria amministrazione; per la straordinaria serve una delibera del direttivo (art. 21). Convoca il direttivo.' },
  { ruolo: 'Vicepresidente', nome: '', fa: 'Sostituisce il presidente quando è assente o impedito (art. 21). Per il resto è un consigliere con un voto come gli altri.' },
  { ruolo: 'Segretario', nome: 'Ivan Napolitano', fa: 'Verbali e libro soci; nelle assemblee online deve essere nello stesso luogo del presidente (art. 14). Oggi cura anche il gestionale.' },
  { ruolo: 'Consigliere', nome: 'Elisa Vizzini', fa: 'Un voto pieno nel direttivo. Può ricevere deleghe su un\'area con delibera (art. 19 h).' },
  { ruolo: 'Tesoriere', nome: '', fa: 'Previsto dallo statuto (art. 19), può essere la stessa persona del segretario. Risponde dei conti e del preventivo. Da verificare se è stato nominato.' },
];

export const COME_DECIDIAMO = [
  ['Il direttivo decide insieme', 'È il direttivo ad avere "i più ampi poteri per la gestione" (art. 19), non una singola persona. Si decide a maggioranza dei presenti, una testa un voto.'],
  ['Il presidente esegue e firma', 'Può fare da solo l\'ordinaria amministrazione. Tutto ciò che è straordinario passa da una delibera (art. 21).'],
  ['Prezzi, contratti e preventivo sono del direttivo', 'Quote e prezzi delle attività (art. 7), contratti (art. 19 d), bilancio preventivo e rendiconto (art. 19 b).'],
  ['Le aree hanno un responsabile', 'Il direttivo nomina i responsabili dei settori e dà deleghe ai suoi membri con delibera (art. 19 f, h). Chi ha la delega decide nei limiti che gli sono stati dati.'],
  ['Quello che non è scritto non è deciso', 'Ogni decisione va a verbale con chi la porta avanti ed entro quando: così si discute dei fatti, non dei ricordi.'],
  ['In quattro si può finire 2 a 2', 'A parità la proposta non passa. Lo statuto permette fino a 5 consiglieri (art. 19): da valutare.'],
];

// I tasselli. area = chi lo porta; dove = pagina del gestionale; manca = cosa succede se questo tassello salta.
export const NODI = {
  delibera: { area: 'DIR', t: 'Decisione scritta del direttivo', dove: '/segreteria', rischio: 'ORGANIZZATIVO',
    cos: 'Verbale con cosa si è deciso, chi lo porta avanti ed entro quando.',
    manca: 'Una decisione presa a voce non esiste: i prezzi, i contratti e le spese straordinarie non hanno base e ognuno ricorda una versione diversa.',
    porta: ['preventivo', 'prezzi', 'contratto', 'campi'] },
  preventivo: { area: 'DIR', t: 'Preventivo della stagione', dove: '/cash/resoconto', rischio: 'ECONOMICO',
    cos: 'Quanto pensiamo di incassare e spendere, area per area, prima che la stagione parta (art. 19 b).',
    manca: 'Ogni spesa diventa una discussione caso per caso, si scopre a fine anno se i conti tornano, i responsabili d\'area non sanno quanto possono spendere.',
    porta: ['prezzi', 'rendiconto'] },
  prezzi: { area: 'DIR', t: 'Prezzi e quote decisi', dove: '/corsisti', rischio: 'ECONOMICO',
    cos: 'Pacchetti, quota di tesseramento, sconti: li stabilisce il direttivo (art. 7).',
    manca: 'Listino cambiato a voce, sconti diversi da persona a persona, famiglie che confrontano e chiedono spiegazioni.',
    porta: ['pagamenti'] },
  campi: { area: 'DIR', t: 'Campi e strutture con contratto', dove: '/strutture', rischio: 'ECONOMICO',
    cos: 'Accordi con le strutture: costi, orari, documenti.',
    manca: 'Gruppi pianificati su campi non confermati, costi della sede che non entrano nel preventivo.',
    porta: ['planning', 'calendario', 'preventivo'] },

  cf: { area: 'SEG', t: 'Codice fiscale della persona', dove: '/anagrafica', rischio: 'ASSICURATIVO',
    cos: 'Il dato da cui parte tutto: lo chiede chiunque iscriva qualcuno (segreteria, allenatore, form).',
    manca: 'La persona resta "CF DA INSERIRE": non si può tesserare, il gestionale non la riconosce e nascono doppioni.',
    porta: ['scheda', 'categoria', 'tessera', 'ricevuta'] },
  scheda: { area: 'SEG', t: 'Una sola scheda per persona', dove: '/anagrafica', rischio: 'ECONOMICO',
    cos: 'Planning, pagamenti, tessere, portale e collaboratori si appoggiano alla stessa scheda.',
    manca: 'Doppioni: pagamenti su una scheda, tessera sull\'altra, controlli che segnalano problemi finti e ne nascondono di veri.',
    porta: ['planning', 'tessera'] },
  categoria: { area: 'TEC', t: 'Open o Under 18', dove: '/planning', rischio: 'SPORTIVO',
    cos: 'Lo dice il codice fiscale, da solo.',
    manca: 'Un minore trattato come adulto: gruppo sbagliato, consensi dei genitori non chiesti.',
    porta: ['planning', 'privacy'] },
  tessera: { area: 'SEG', t: 'Tessera ASI della stagione', dove: '/tesseramenti', rischio: 'ASSICURATIVO',
    cos: 'Per chi fa i corsi la ASI B della stagione; l\'import la aggancia dal codice fiscale.',
    manca: 'La persona fa attività senza essere tesserata.',
    porta: ['assicurazione', 'istituzionale', 'sconto_tornei'] },
  librosoci: { area: 'SEG', t: 'Libro soci aggiornato', dove: '/segreteria', rischio: 'ORGANIZZATIVO',
    cos: 'Chi è socio, con la quota pagata.',
    manca: 'Non si sa chi ha diritto di voto: l\'assemblea è contestabile.',
    porta: ['assemblea'] },
  privacy: { area: 'SEG', t: 'Informativa e consensi', dove: '/form', rischio: 'FIDUCIA',
    cos: 'Presa visione dell\'informativa, consensi per foto e comunicazioni (per i minori, dei genitori).',
    manca: 'Foto e messaggi inviati senza consenso: reclami e problemi col GDPR.',
    porta: ['comunicazione'] },

  planning: { area: 'TEC', t: 'Atleta nel gruppo giusto, gruppo avviato', dove: '/planning', rischio: 'ECONOMICO',
    cos: 'Il gruppo passa IN CORSO e gli atleti arrivano in Pagamento corsi.',
    manca: 'Chi non è in un gruppo avviato non compare tra i pagamenti: nessuno gli chiede la quota.',
    porta: ['pagamenti'] },
  contratto: { area: 'TEC', t: 'Contratto del collaboratore', dove: '/dipendenti/contratti', rischio: 'FISCALE',
    cos: 'Generato, accettato dal portale e firmato in originale.',
    manca: 'L\'allenatore lavora senza contratto: compensi senza base, problemi in caso di controllo o infortunio.',
    porta: ['presenze'] },
  presenze: { area: 'TEC', t: 'Presenze inserite e confermate', dove: '/dipendenti/calendario', rischio: 'ECONOMICO',
    cos: 'La segreteria inserisce o approva, l\'allenatore conferma.',
    manca: 'Paga sbagliata, allenatore scontento, discussioni a fine mese.',
    porta: ['autocert', 'paghe'] },
  autocert: { area: 'TEC', t: 'Autocertificazione compensi del mese', dove: '/dipendenti/paghe', rischio: 'FISCALE',
    cos: 'L\'allenatore dichiara quanto ha preso da altre associazioni nell\'anno.',
    manca: 'Il tasto Confermo resta spento e la paga si blocca; senza la dichiarazione non si sa se si superano 5.000 o 15.000 €.',
    porta: ['paghe', 'contributi'] },

  pagamenti: { area: 'AMM', t: 'Quota e pacchetto registrati', dove: '/corsisti', rischio: 'ECONOMICO',
    cos: 'Ogni atleta con il suo pacchetto, rate e pagamenti.',
    manca: 'Quote non chieste o chieste due volte, solleciti alle persone sbagliate.',
    porta: ['banca', 'ricevuta'] },
  istituzionale: { area: 'AMM', t: 'Quote da soci e tesserati', dove: '/tesseramenti', rischio: 'FISCALE',
    cos: 'Lo statuto (art. 11) e le regole delle ASD trattano in modo agevolato i corrispettivi pagati da associati e tesserati.',
    manca: 'La quota pagata da chi non è tesserato rischia di essere considerata un ricavo commerciale.',
    porta: ['fisco'] },
  ricevuta: { area: 'AMM', t: 'Ricevuta completa', dove: '/corsisti', rischio: 'FIDUCIA',
    cos: 'Con il codice fiscale dell\'atleta e di chi paga.',
    manca: 'Ricevuta incompleta o da rifare a mano.',
    porta: ['detrazione'] },
  detrazione: { area: 'COM', t: 'Detrazione per le famiglie', dove: '/corsisti', rischio: 'FIDUCIA',
    cos: 'Per i ragazzi dai 5 ai 18 anni la famiglia può detrarre la spesa: servono ricevuta con CF e pagamento tracciabile.',
    manca: 'Pagato in contanti o ricevuta senza CF: la famiglia perde la detrazione e se la prende con noi.',
    porta: [] },
  contanti: { area: 'AMM', t: 'Contanti con ricevuta e prima nota', dove: '/cash/banca', rischio: 'FISCALE',
    cos: 'Regola del commercialista: sotto 1.000 €, ricevuta, scheda CONTANTI e giustificativi.',
    manca: 'Soldi che non si sa da dove arrivano né dove vanno; il rendiconto non torna.',
    porta: ['rendiconto', 'detrazione'] },
  banca: { area: 'AMM', t: 'Banca che quadra', dove: '/cash/banca', rischio: 'ECONOMICO',
    cos: 'Estratto importato, movimenti con categoria, controllo con il PDF della banca.',
    manca: 'Non sappiamo quanto abbiamo davvero né quale attività guadagna o perde.',
    porta: ['rendiconto'] },
  paghe: { area: 'AMM', t: 'Paga del mese chiusa', dove: '/dipendenti/paghe', rischio: 'ECONOMICO',
    cos: 'Lordo, contributi, bonifico, mese chiuso.',
    manca: 'Bonifici sbagliati o in ritardo, costo dei collaboratori sconosciuto.',
    porta: ['banca', 'contributi'] },
  contributi: { area: 'AMM', t: 'Soglie e contributi', dove: '/dipendenti/paghe', rischio: 'FISCALE',
    cos: 'Oltre 5.000 € nell\'anno scattano gli obblighi INPS, oltre 15.000 € anche l\'IRPEF (somma di tutte le associazioni).',
    manca: 'Contributi non versati, sanzioni, costo inatteso per l\'associazione.',
    porta: ['fisco'] },
  rendiconto: { area: 'AMM', t: 'Rendiconto dell\'anno', dove: '/cash/resoconto', rischio: 'FISCALE',
    cos: 'Lo prepara il direttivo, lo approva l\'assemblea entro 4 mesi dalla chiusura (art. 12). Attenzione: l\'esercizio va dal 1/1 al 31/12, la stagione sportiva dal 1/9 al 31/8.',
    manca: 'Assemblea senza documento da approvare, adempimenti saltati.',
    porta: ['assemblea'] },

  assicurazione: { area: 'DIR', t: 'Copertura assicurativa', dove: '/tesseramenti', rischio: 'ASSICURATIVO',
    cos: 'La copertura infortuni di base arriva con la tessera.',
    manca: 'Se la persona si fa male non è coperta.',
    porta: ['responsabilita'] },
  responsabilita: { area: 'DIR', t: 'Responsabilità di chi guida l\'associazione', dove: null, rischio: 'ASSICURATIVO',
    cos: 'Nelle associazioni non riconosciute (il caso più comune tra le ASD) per gli impegni presi risponde anche personalmente chi ha agito in nome dell\'associazione (art. 38 c.c.).',
    manca: 'Un danno non coperto può ricadere sull\'associazione e su chi la rappresenta.',
    porta: [] },
  assemblea: { area: 'DIR', t: 'Assemblea valida', dove: '/segreteria', rischio: 'ORGANIZZATIVO',
    cos: 'Convocata almeno 10 giorni prima, con i soci in regola con la quota (art. 14).',
    manca: 'Rendiconto non approvato o delibere contestabili.',
    porta: ['fisco'] },
  fisco: { area: 'DIR', t: 'Agevolazioni da ASD', dove: null, rischio: 'FISCALE',
    cos: 'Il regime agevolato vale finché l\'associazione è in regola: tesserati, rendiconto, assemblea, compensi corretti.',
    manca: 'In caso di controllo: ricavi ripresi a tassazione, imposte e sanzioni.',
    porta: [] },

  calendario: { area: 'EVE', t: 'Calendario attività aggiornato', dove: '/calendario', rischio: 'ORGANIZZATIVO',
    cos: 'Eventi, tornei, campi occupati, chi dello staff è presente.',
    manca: 'Campi occupati due volte, staff che non sa dove deve essere, famiglie avvisate tardi.',
    porta: ['comunicazione'] },
  tessera_fipav: { area: 'EVE', t: 'Tessera FIPAV', dove: '/tornei-fipav', rischio: 'SPORTIVO',
    cos: 'Serve per giocare i tornei federali e prendere punti.',
    manca: 'La coppia non può essere iscritta, o resta in lista d\'attesa.',
    porta: ['torneo'] },
  sconto_tornei: { area: 'EVE', t: 'Prezzo giusto ai tornei', dove: '/contabilita-tornei', rischio: 'ECONOMICO',
    cos: 'Lo sconto vale per chi ha ASI A o è nel planning/AIBVC.',
    manca: 'Sconti dati a chi non spetta, o negati a chi spetta.',
    porta: ['torneo'] },
  torneo: { area: 'EVE', t: 'Torneo in ordine', dove: '/contabilita-tornei', rischio: 'ECONOMICO',
    cos: 'Iscritti, incassi, spese e chiusura del torneo.',
    manca: 'Incassi del torneo che non si ritrovano in banca.',
    porta: ['banca'] },
  comunicazione: { area: 'COM', t: 'Comunicazione puntuale', dove: '/calendario', rischio: 'FIDUCIA',
    cos: 'Email, avvisi, social: le persone sanno cosa succede e quando.',
    manca: 'Persone che si sentono trascurate, iscrizioni perse, passaparola negativo.',
    porta: [] },
};

// Catene raccontate: sequenze di tasselli. La pagina le disegna come un domino.
export const CATENE = [
  { titolo: 'Il codice fiscale che non arriva', intro: 'Sembra un dettaglio di segreteria. È il primo pezzo del domino.',
    passi: ['cf', 'tessera', 'assicurazione', 'responsabilita'] },
  { titolo: 'La quota del corsista non tesserato', intro: 'L\'atleta paga, si allena, tutto sembra in ordine.',
    passi: ['cf', 'tessera', 'istituzionale', 'fisco'] },
  { titolo: 'I contanti senza ricevuta', intro: 'Comodo sul momento, costoso dopo.',
    passi: ['contanti', 'detrazione'] },
  { titolo: 'Il gruppo mai avviato', intro: 'Il gruppo si allena davvero, ma nel gestionale è ancora in bozza.',
    passi: ['planning', 'pagamenti', 'banca', 'rendiconto'] },
  { titolo: 'La presenza non inserita', intro: 'Un allenamento fatto ma non segnato.',
    passi: ['presenze', 'autocert', 'paghe', 'contributi', 'fisco'] },
  { titolo: 'La decisione presa a voce', intro: '"L\'avevamo detto": ma nessuno l\'ha scritto.',
    passi: ['delibera', 'prezzi', 'pagamenti', 'ricevuta'] },
  { titolo: 'Il preventivo che non c\'è', intro: 'Senza un piano ogni spesa è una discussione.',
    passi: ['preventivo', 'prezzi', 'pagamenti', 'banca', 'rendiconto', 'assemblea'] },
];
